import React, { useState, useEffect } from "react"
import Pagination from "./pagination"
import BlogPostGallery from "./blog-post-gallery"

const BlogHome = () => {
  const [searchResultCount, setSearchResultCount] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)

  return (
    <div className="w-full max-w-[590px] md:max-w-full pb-10 md:pb-14 lg:pb-[96px] px-4 lg:px-14 mx-auto md:mx-0">
      <div id="com-aldoo-books-button"></div>
      <BlogPostGallery
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setTotalPages={setTotalPages}
        setSearchResultCount={setSearchResultCount}
      />

      <Pagination
        totalPages={totalPages} // Assuming this is the total number of pages
        currentPage={currentPage} // Assuming this is the current page
        onPageChange={(page) => {
          // Assuming this function will navigate to the selected page
          setCurrentPage(page)
        }}
      />
    </div>
  )
}

export default BlogHome
